import * as React from "react";
import { forwardRef } from "react";
const SvgShockSensor = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 17, fill: "#fff", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.9, d: "m15.101 2.606 1.9 2.85-1.9 2.852 1.9 2.85-1.9 2.852M2.901 2.606 1 5.456l1.9 2.852-1.9 2.85 1.9 2.852M7.472 1.145h3.062c.422 0 .765.712.765 1.591V13.88c0 .88-.343 1.592-.765 1.592H7.47c-.423 0-.765-.713-.765-1.592V2.736c0-.879.342-1.591.765-1.591" }));
const ForwardRef = forwardRef(SvgShockSensor);
export { ForwardRef as ReactComponent };
